const HandlerLogin       = () => import("@/pages/handler/HandlerLogin.vue");
const HandlerSearch      = () => import("@/pages/handler/HandlerSearch.vue");
const HandlerPickupIn    = () => import("@/pages/handler/HandlerPickupGateIn.vue");
const HandlerPickupOut   = () => import("@/pages/handler/HandlerPickupGateOut.vue");
const HandlerDropIn      = () => import("@/pages/handler/HandlerDropGateIn.vue");
// const HandlerDropOut     = () => import("@/pages/handler/HandlerDropGateOut.vue");  // not needed — drop_gate_out auto-triggered at drop_gate_in

export default [
  { path: "login",                    name: "HandlerLogin",       component: HandlerLogin  },
  { path: "search",                   name: "HandlerSearch",      component: HandlerSearch },
  { path: "eo/:id/pickup-gate-in",    name: "HandlerPickupGateIn",  component: HandlerPickupIn  },
  { path: "eo/:id/pickup-gate-out",   name: "HandlerPickupGateOut", component: HandlerPickupOut },
  { path: "eo/:id/drop-gate-in",      name: "HandlerDropGateIn",    component: HandlerDropIn    },
  // { path: "eo/:id/drop-gate-out",     name: "HandlerDropGateOut",   component: HandlerDropOut   },  // not needed — drop_gate_out auto-triggered at drop_gate_in
];
